import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexProgress',
  setup(__props) {

const basicProgressbar = defineAsyncComponent(() => import("@/components/theme/uikits/progress/basicProgressbar.vue"))
const stripedProgressbar = defineAsyncComponent(() => import("@/components/theme/uikits/progress/stripedProgressbar.vue"))
const multipleBars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/multipleBars.vue"))
const customProgressbars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/customProgressbars.vue"))
const smallProgressbars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/smallProgressbars.vue"))
const heightProgressbars = defineAsyncComponent(() => import("@/components/theme/uikits/progress/heightProgressbars.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Progress"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(basicProgressbar)),
          _createVNode(_unref(stripedProgressbar)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(multipleBars))
          ]),
          _createVNode(_unref(customProgressbars)),
          _createVNode(_unref(smallProgressbars)),
          _createVNode(_unref(heightProgressbars))
        ])
      ])
    ])
  ], 64))
}
}

})